<template>
  <div class="footer-wrap">
    <div class="pc-body">
      <div>联系我们</div>
      <div class="num">
        <img src="@/assets/icon_call@2x.png" class="icon-foot" alt />
        400-092-9009
      </div>
      <div class="fs_14">
        <img src="@/assets/icon_address@2x.png" class="icon-foot" alt />
        中国（四川）自由贸易试验区天府新区兴隆街道集萃街619号
      </div>
      <div class="fs_14 record">
        © 2022 思极星能科技（四川）有限公司 All rights reserved.
        <a
          href="https://beian.miit.gov.cn/"
          class="record-number"
          target="_blank"
          >蜀ICP备2021017644号-2</a
        >
        <a
          href="https://www.aostarit.com.cn/antiCorruptionReport"
          style="margin-left: 10px"
          class="record-number"
          target="_blank"
          >廉政举报</a
        >
        <router-link
          to="/projectPublic"
          style="margin-left: 10px"
          class="record-number"
          tag="a"
          >项目公示</router-link
        >
      </div>
    </div>

    <div class="footer-mobile">
      <div class="title about-title">
        <div class="title__zh">联系我们</div>
        <div class="title__en">CONTACT US</div>
        <div class="title__line"></div>
      </div>

      <div class="label">客服热线</div>
      <div class="num">
        <!--<img src="@/assets/icon_call@2x.png" class="icon-foot" alt />-->
        400-092-9009
        <img src="@/assets/m_icon_call@2x.png" class="icon-foot" alt />
      </div>
      <div class="label label2">公司地址</div>
      <div class="fs_14">
        <!--<img src="@/assets/icon_address@2x.png" class="icon-foot" alt />-->
        中国（四川）自由贸易试验区天府新区兴隆街道集萃街619号
      </div>
      <div class="fs_14 record">
        © 2022 思极星能科技（四川）有限公司 All rights reserved.
        <a
          href="https://beian.miit.gov.cn/"
          class="record-number-mobile"
          target="_blank"
          >蜀ICP备2021017644号-2</a
        >
        <a
          href="https://www.aostarit.com.cn/antiCorruptionReport"
          style="margin-left: 20px"
          class="record-number"
          target="_blank"
          >廉政举报</a
        >
        <router-link
          to="/projectPublic"
          style="margin-left: 20px"
          class="record-number"
          tag="a"
          >项目公示</router-link
        >
      </div>
    </div>
    <div class="right-footer">
      <div class="r-item first-item">
        <div class="r-img"><img src="@/assets/img_xcpqr.png" alt /></div>
        <div class="fs_14">星城配APP</div>
      </div>
      <div class="r-item">
        <div class="r-img"><img src="@/assets/img_sjncdqr.jpg" alt /></div>
        <div class="fs_14">极能充APP</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
<style scoped lang="less">
.record-number {
  color: rgba(123, 154, 235, 0.71);
}
.record-number-mobile {
  color: rgba(123, 154, 235, 0.71);
}
.record-number:hover {
  color: #3afefe;
}
@media screen and (min-width: 481px) {
  .pc-body {
    display: block;
  }
  .footer-mobile {
    display: none;
  }
  .fs_14 {
    font-size: 18px;
  }
  .record {
    position: relative;
    top: 16px;
    font-size: 14px;
    color: rgba(123, 154, 235, 0.71);
  }
  .footer-wrap {
    color: #7b9aeb;
    font-size: 16px;
    padding: 20px 100px;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: space-around;
    .num {
      font-size: 24px;
    }
    div {
      line-height: 1.8;
    }
    .icon-foot {
      width: 18px;
      height: 18px;
      margin-right: 3px;
    }
    .right-footer {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      text-align: center;
      margin-top: 10px;
      .first-item {
        margin-right: 59px;
      }
      .r-item {
        height: 120px;
        .r-img {
          background-color: #fff;
          border-radius: 5px;
          height: 80px;
          width: 80px;
          margin: 0 auto;
          text-align: center;
          padding: 5px;
          img {
            height: 80px;
            width: 80px;
          }
        }
        .fs_14 {
          line-height: 2.5;
        }
      }
    }
  }
}
@media screen and (max-width: 480px) {
  .pc-body {
    display: none;
  }
  .footer-mobile {
    display: block;
    width: 275px;
    margin: 80px auto 40px;
    color: #7b9aeb;
    font-size: 16px;
    .label {
      margin-top: 20px;
      line-height: 1.8;
    }
    .label2 {
      margin-top: 10px;
    }
  }
  .title {
    margin: 0 auto;
    text-align: left;
    &__zh {
      font-size: 36px;
      color: @white;
    }
    &__en {
      color: @text-primary;
      text-transform: uppercase;
    }
    &__line {
      margin-top: 8px;
      width: 30px;
      height: 3px;
      background: linear-gradient(
        90deg,
        rgba(25, 114, 242, 1) 0%,
        rgba(253, 133, 186, 1) 100%
      );
      border-radius: 10em;
    }
  }

  .fs_14 {
    font-size: 18px;
  }
  .record {
    position: relative;
    top: 16px;
    font-size: 14px;
    color: rgba(123, 154, 235, 0.71);
  }
  .footer-wrap {
    width: calc(100% - 40px);
    box-sizing: border-box;
    .num {
      font-size: 24px;
    }
    div {
      line-height: 1.4;
    }
    .icon-foot {
      width: 30px;
      height: 30px;
      margin-bottom: 10px;
    }
    .right-footer {
      width: 275px;
      margin: 0 auto;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      text-align: center;
      margin-top: 10px;
      .first-item {
        margin-right: 40px;
      }
      .r-item {
        height: 120px;
        .r-img {
          background-color: #fff;
          border-radius: 5px;
          height: 80px;
          width: 80px;
          margin: 0 auto;
          text-align: center;
          padding: 5px;
          img {
            height: 80px;
            width: 80px;
          }
        }
        .fs_14 {
          line-height: 2.5;
        }
      }
    }
  }
}
</style>
